<template>
    <div class="store_shop_list_con">
        <div class="shop_title_tip">
            请将商品添加至购物车后统一提交订单，当前展示价格为客户售价
        </div>
        <div class="search-header">
            <div class="search-bar">
                <img src="../../assets/img/icons/icon19.png" class="search-icon" />
                <input v-model="searchKeyword" class="search-input" @confirm="handleSearch" @change="handleSearch" type="text"
                    placeholder="搜索你想要的商品" placeholder-style="color:#999" focus />
            </div>
            <div class="cart-btn">
                <img src="../../assets/img/icons/carticon.png" class="cart-icon" />
                <div class="cart-count">{{ cartCount }}</div>
            </div>
        </div>
        <div class="shop_type_con">
            <div class="type_list" :class="{ 'active': feature === item.uuid }" v-for="(item, index) in shopcategory"
                :key="index" @click="handleType(item.uuid)">{{ item.name }}</div>
        </div>
        <div class="grid-container">
            <div class="goods-card" v-for="(item, index) in storeshoplist" :key="index">
                <img class="goods-img" :src="comapi.getImageUrl(item.cover_image)" mode="aspectFill" />
                <div class="goods-info">
                    <text class="goods-name">{{ item.name }}</text>
                    <div class="price-row">
                        <div class="price-box">
                            <text class="symbol">¥</text>
                            <text class="num">{{ item?.skus[0].shop_purchase_price }}</text>
                            <text class="unit">/{{ item?.skus[0].unit }}</text>
                        </div>
                        <div class="cart-btn">
                            <img src="../../assets/img/icons/icon6.png" class="icon-img" mode="aspectFill"
                                @click="openSku(item)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="no-more" v-if="!finished && !loading && storeshoplist.length === 0">暂无数据</div>
        <!-- 加载状态 -->
        <div class="loading" v-if="loading">加载中...</div>
        <div class="no-more" v-if="finished">没有更多了</div>
        <div style="height: 80px;"></div>
        <SkuModal :show="showSkuModal" :productInfo="currentProduct" @confirm="handleConfirm" @close="showSkuModal = false" />
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import storeapi from "@/utils/api/store"
import comapi from "@/utils/api/com"
import { showToast } from 'vant';
import SkuModal from '@/components/skumodel.vue'

const feature = ref(0);//当前分类
const cartCount = ref(0)
const storeshoplist = ref([])
const shopcategory = ref([])
const page = ref(1)
const pageSize = 10
const loading = ref(false)
const finished = ref(false)
const searchKeyword = ref('')
const showSkuModal = ref(false)
const currentProduct = ref({})
// 更新购物车数量
const updateCartCount = () => {
    cartCount.value = JSON.parse(localStorage.getItem('cart_data_list'))?.length || 0
}
// 处理分类点击
const handleType = (uuid) => {
    feature.value = uuid
    storeshoplist.value = []
    page.value = 1
    finished.value = false
    fetchList()
}
//搜名称
const handleSearch = () => {
    storeshoplist.value = []
    page.value = 1
    finished.value = false
    fetchList()
}
const fetchList = async () => {
    if (loading.value || finished.value) return
    loading.value = true
    try {
        const res = await storeapi.getstoreshoplist({
            category_uuid: feature.value,
            name: searchKeyword.value,
            page: page.value,
            page_size: pageSize
        })
        const records = res?.data || []
        // 追加数据
        storeshoplist.value.push(...records)
        // 判断是否还有下一页
        if (records.length < pageSize) {
            finished.value = true
        } else {
            page.value++
        }
    } catch (error) {
        showToast(error.message || '获取门店商品列表失败')
    } finally {
        loading.value = false
    }
}

/**
 * 滚动到底部加载
 */
const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight

    if (scrollTop + clientHeight >= scrollHeight - 20) {
        fetchList()
    }
}
// 打开商品详情/添加到购物车
const openSku = (item) => {
    // 打开规格弹窗
    currentProduct.value = item
    showSkuModal.value = true
}
// 确认添加到购物车
const handleConfirm = () => {
    // 手动更新购物车数量
    updateCartCount()
    showSkuModal.value = false
}
//分类
const getshopcategory = async () => {
    const res = await storeapi.getshopcategory()
    const records = res?.data || []
    // 追加数据
    shopcategory.value = records
}

// 监听 localStorage 变化
const handleStorageChange = (e) => {
    if (e.key === 'cart_data_list') {
        updateCartCount()
    }
}

onMounted(() => {
    getshopcategory()
    updateCartCount()
    fetchList()
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('storage', handleStorageChange)
})
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    window.removeEventListener('storage', handleStorageChange)
})
</script>
<style lang="less" scoped>
.store_shop_list_con {
    min-height: 100vh;

    .shop_title_tip {
        padding: 10px 18px;
        background: rgba(220, 187, 137, 0.08);
        font-weight: 500;
        font-size: 13px;
        color: #9A753E;
    }

    .search-header {
        padding: 10px 18px 0 18px;
        display: flex;
        justify-content: space-between;

        .search-bar {
            display: flex;
            align-items: center;
            height: 49px;
            background-color: #fff;
            border-radius: 8px;
            padding: 0 12px;
            width: 100%;
            margin-right: 10px;

            .search-icon {
                width: 23px;
                height: 23px;
                margin-right: 6px;
            }

            .search-input {
                flex: 1;
                font-size: 13px;
                color: #333;
                border: none;
                outline: none;
            }
        }

        .cart-btn {
            position: relative;

            .cart-icon {
                width: 28px;
                height: 28px;
            }

            .cart-count {
                position: absolute;
                top: 0;
                right: -10px;
                width: 18px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                font-size: 10px;
                color: #fff;
                background-color: #FF7123;
                border-radius: 50%;
            }
        }
    }

    .shop_type_con {
        padding: 0 18px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .type_list {
            background: #F3EDE3;
            border-radius: 4px;
            font-size: 13px;
            color: #9A753E;
            padding: 3px 12px;
            margin-bottom: 6px;
            margin-right: 8px;
        }

        .active {
            background: #FF7123;
            color: #fff;
        }
    }

    .loading,
    .no-more {
        text-align: center;
        padding-bottom: 15px;
        color: #999;
        font-size: 14px;
    }

    .grid-container {
        padding: 10px 18px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .goods-card {
            width: 48%;
            background-color: #FFF;
            border-radius: 4px;
            overflow: hidden;
            margin-bottom: 12px;
            position: relative;

            .goods-img {
                width: 100%;
                height: 152px;
                background-color: #EEE;
                display: block;
            }

            .goods-info {
                padding: 8px;

                .goods-name {
                    font-size: 14px;
                    color: #333;
                    font-weight: bold;
                    margin-bottom: 8px;
                    display: block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .price-row {
                    display: flex;
                    justify-content: space-between;

                    .price-box {
                        color: #FF7123;
                        align-items: baseline;
                        display: flex;

                        .symbol {
                            font-size: 20px;
                            margin-right: 2px;
                        }

                        .num {
                            font-size: 20px;
                            font-weight: bold;
                        }

                        .unit {
                            font-size: 14px;
                            color: #999;
                            margin-left: 2px;
                        }
                    }

                    .cart-btn {
                        width: 25px;
                        height: 25px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .icon-img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
}
</style>
